import automation from "../../api/automation";
import { perPageCount } from "@/common/constants";
import { dummyRows, StatusIcon, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      date_from: "",
      date_to: "",
      senderId: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      _route: "automation_report",
      add_sort: 0,
    },
    totalItems: 0,
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
    detailItems: {},
    detailLoaded: false,
    campaignWiseReport: [],
    campaignWiseLoaded: false,
    campaignWiseBusyLoader: true,
    autoName: "",
    reportId: "",
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getReportItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    var tempItem = [];
    for (var i = 0; i < state.items.length; i++) {
      var openRate = 0;
      if (state.items[i].opens > 0) {
        openRate =
          state.items[i].sent > 0
            ? (state.items[i].opens / state.items[i].sent) * 100
            : 0;
        openRate = openRate.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        openRate = openRate.replace(".00", "");
      }
      var clickRate = 0;
      if (state.items[i].click > 0) {
        clickRate = (state.items[i].click / state.items[i].opens) * 100;
        clickRate = clickRate.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        clickRate = clickRate.replace(".00", "");
      }
      var unsubsRate = 0;
      if (state.items[i].unsubs > 0) {
        unsubsRate = (state.items[i].unsubs / state.items[i].opens) * 100;
        unsubsRate = unsubsRate.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        unsubsRate = unsubsRate.replace(".00", "");
      }
      var getPauseMessage = (item) => {
        var pauseMessage = item.pause_message ? item.pause_message : "";
        var pausemsg = [
          "Client quota exceeded. Automation deactivated.",
          "Your subscription is unpaid. Automation deactivated.",
          "Your subscription is canceled. Automation deactivated.",
          "Your subscription is expired. Automation deactivated.",
        ];
        if (
          parseInt(item.status) === 0 &&
          pauseMessage &&
          pausemsg.includes(pauseMessage)
        ) {
          return pauseMessage;
        } else {
          return "";
        }
      };
      tempItem.push({
        pause_message: getPauseMessage(state.items[i]),
        id: state.items[i].id,
        autoName: {
          title: state.items[i].name,
          text: "Created at " + state.items[i].createddate,
        },
        sent: convertCount(state.items[i].sent ? state.items[i].sent : 0),
        opens: {
          first: openRate + "%",
          second: convertCount(state.items[i].opens ? state.items[i].opens : 0),
        },
        auto_status: {
          text: state.items[i].status_label,
          type: StatusIcon(state.items[i].status_label),
        },
        click: {
          first: clickRate + "%",
          second: convertCount(state.items[i].click ? state.items[i].click : 0),
        },
        unsubs: {
          first: unsubsRate + "%",
          second: convertCount(
            state.items[i].unsubs ? state.items[i].unsubs : 0
          ),
        },
      });
    }
    return tempItem;
  },
  getDeliverabilityChartData: (state) => {
    var obj = { Delivered: 0, Queue: 0, "Soft bounce": 0, "Hard bounce": 0 };
    if (
      state.detailItems.delivery_report &&
      state.detailItems.delivery_report.report
    ) {
      var deliveryReport = state.detailItems.delivery_report.report;
      for (var i in deliveryReport) {
        var data = deliveryReport[i];
        obj[data.label] = parseInt(data.value);
      }
    }
    return Object.values(obj);
  },
  getDeliverabilityListData: (state) => {
    var obj = {
      "Total volume": {
        label: "Total volume",
        bgclass: "bg-white",
        value: 0,
        percentage: 0,
      },
      Delivered: {
        label: "Delivered",
        bgclass: "bg-delivered",
        value: 0,
        percentage: 0,
      },
      Queue: {
        label: "Queue",
        bgclass: "bg-queue",
        value: 0,
        percentage: 0,
      },
      "Soft bounce": {
        label: "Soft bounce",
        bgclass: "bg-soft-bounce",
        value: 0,
        percentage: 0,
      },
      "Hard bounce": {
        label: "Hard bounce",
        bgclass: "bg-hard-bounce",
        value: 0,
        percentage: 0,
      },
    };
    if (
      state.detailItems.delivery_report &&
      state.detailItems.delivery_report.report
    ) {
      var deliveryReport = state.detailItems.delivery_report.report;
      obj["Total volume"].value =
        state.detailItems.delivery_report.total_volume;
      for (var i in deliveryReport) {
        var data = deliveryReport[i];
        obj[data.label].value = parseInt(data.value);
        obj[data.label].percentage = parseInt(data.percentage);
      }
    }
    return Object.values(obj);
  },
  getEngagementChartData: (state) => {
    var obj = {
      Open: 0,
      Click: 0,
      Unsubscribe: 0,
      Abuse: 0,
      "Spam complaints": 0,
    };
    if (
      state.detailItems.engagment_report &&
      state.detailItems.engagment_report.report
    ) {
      var engage = state.detailItems.engagment_report.report;
      for (var i in engage) {
        var data = engage[i];
        obj[data.label] = parseInt(data.value);
      }
    }
    return Object.values(obj);
  },
  getEngagementListData: (state) => {
    var obj = {
      Open: {
        label: "Open",
        bgclass: "bg-open",
        value: 0,
        percentage: 0,
      },
      Click: {
        label: "Click",
        bgclass: "bg-click",
        value: 0,
        percentage: 0,
      },
      Unsubscribe: {
        label: "Unsubscribe",
        bgclass: "bg-unsubscribe",
        value: 0,
        percentage: 0,
      },
      Abuse: {
        label: "Abuse",
        bgclass: "bg-abuse",
        value: 0,
        percentage: 0,
      },
      "Spam complaints": {
        label: "Spam complaints",
        bgclass: "bg-spam-complaints",
        value: 0,
        percentage: 0,
      },
    };
    if (
      state.detailItems.engagment_report &&
      state.detailItems.engagment_report.report
    ) {
      var engage = state.detailItems.engagment_report.report;
      for (var i in engage) {
        var data = engage[i];
        obj[data.label].value = parseInt(data.value);
        obj[data.label].percentage = parseInt(data.percentage);
      }
    }
    return Object.values(obj);
  },
  getCampaignWiseItems: (state) => {
    if (!state.campaignWiseReport.length && !state.campaignWiseLoaded) {
      return dummyRows(5);
    }

    return state.campaignWiseReport.map((item) => {
      return {
        autoCampName: item.name,
        openRate: { first: item.open_percentage + "%", second: item.opens },
        sentto: item.sent,
        clicks: { first: item.click, second: item.click_percentage + "%" },
        unsubs: {
          first: item.unsubscribe,
          second: item.unsubscribe_percentage + "%",
        },
        id: item.camp_id,
        status: item.status,
        contenttype: item.contenttype,
      };
    });
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.senderId !== params.senderId ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve, reject) {
        automation.fetchItems(params, (data) => {
          if (data.message) {
            reject(data.message);
          }
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },
  fetchDetailItems({ commit }, id) {
    commit("setDetailLoaded", false);
    return new Promise(function (resolve) {
      automation.automationReport(id).then((data) => {
        commit("setDetailItems", { items: data.data });
        commit("setAutoName", data.data.name);
        commit("setDetailLoaded", true);
        resolve(true);
      });
    });
  },
  exportItems(_, params) {
    var name = "automation_report.csv";
    return automation.exportItems(params, { name });
  },
  fetchCampaignWiseReport({ commit }, id) {
    return new Promise(function (resolve) {
      commit("setCampaignWiseBusyLoader", true);
      commit("setCampaignWiseLoaded", false);
      automation.automationCampaignReport(id).then((data) => {
        commit("setCampaignWiseReport", data.data);
        commit("setCampaignWiseLoaded", true);
        commit("setCampaignWiseBusyLoader", false);
        resolve(true);
      });
    });
  },
};

// mutations
const mutations = {
  setReportId(state, id) {
    state.reportId = id;
  },

  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },

  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },

  setShowFilter(state, status) {
    state.showFilter = status;
  },

  setTotal(state, total) {
    state.total = total;
  },

  setAutoName(state, name) {
    state.autoName = name;
  },

  setDetailItems(state, { items }) {
    state.detailItems = items;
  },

  setDetailLoaded(state, loaded) {
    state.detailLoaded = loaded;
  },
  setCampaignWiseReport(state, data) {
    state.campaignWiseReport = data;
  },
  setCampaignWiseLoaded(state, status) {
    state.campaignWiseLoaded = status;
  },
  setCampaignWiseBusyLoader(state, status) {
    state.campaignWiseBusyLoader = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
